import { useState, useEffect } from "react";
import { Box, Typography, Tooltip, IconButton, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { useRecoilState } from "recoil";
import { rsProgress } from "../../RecoilStates";
import CustomPagination from "../../components/CustomPagination";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import DeleteRow from "../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import VideoOperation from "./VideoOperation";
import { UseProductVideos } from "./UseProductVideos";
import EditIcon from "@mui/icons-material/Edit";

export default function VideosList(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [searchSubGroup, setSearchSubGroup] = useState("");
  const { updateVideo, deleteVideo } = UseProductVideos();
  const [data, setData] = useState();
  const [filt, setFilt] = useState([]);
  const [openDialog, setOpenDialog] = useState({
    show: false,
    data: undefined,
  });

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    if (props.rows) {
      setData(props.rows);
    }
  }, [props.rows]);

  useEffect(() => {
    setFilt([
      {
        columnField: "productName",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const columns = [
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "id",
      width: 90,
      align: "center",
      headerName: "کد ویدیو",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "url",
      width: 500,
      align: "center",
      headerName: "لینک ویدیو",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              direction: "rtl",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {cellValues.row.url}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 160,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  setOpenDialog({ show: true, data: cellValues.row });
                }}
              >
                <EditIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="حذف">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  productVideoID: cellValues.row.productVideoID,
                  url: cellValues.row.url,
                  rowIndex: cellValues.row.rowIndex - 1,
                };
                if (cellValues.row.rowIndex - 1 == 0) {
                  return;
                } else {
                  setProgress(true);
                  updateVideo(model, () => props.onCallback());
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  productVideoID: cellValues.row.productVideoID,
                  url: cellValues.row.url,
                  rowIndex: cellValues.row.rowIndex + 1,
                };

                if (cellValues.row.rowIndex + 1 == props.rows.length + 1) {
                  return;
                } else {
                  updateVideo(model, () => props.onCallback());
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" sx={{}} />
            </IconButton>
          </>
        );
      },
    },
  ];

  const newFunc = () => {
    setOpenDialog({ show: true, data: null });
  };

  return (
    <Box sx={{ height: "30rem", mb: 5 }}>
      <DataGrid
        className="ltr-grid"
        filterModel={{
          items: filt,
        }}
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={data ? data : []}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={data && data.length ? data.length : 1}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            newFunc: newFunc,
            isLtr: true,
            rowCount: data && data.length ? data.length : "",
          },
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "rowIndex",
                sort: "asc",
              },
            ],
          },
        }}
      />

      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"ویدیو"}
        callback={() => {
          setProgress(true);
          deleteVideo(deleteState.id, () => {
            props.onCallback();
          });
        }}
      ></DeleteRow>
      {openDialog.show && (
        <VideoOperation
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          productVideoID={props.productVideoId ?? 0}
          videos={data ?? []}
          callback={() => {
            props.onCallback();
            setOpenDialog({ show: false, data: null });
          }}
        />
      )}
    </Box>
  );
}
